// extracted by mini-css-extract-plugin
export default {"adornment":"adornment--Mr7hb"};